import React from "react";

const TEAL = { bg: "rgba(62,221,166,0.12)", text: "#5CE3B4", border: "rgba(62,221,166,0.32)" };
const AMBER = { bg: "rgba(224,178,62,0.12)", text: "#E7C169", border: "rgba(224,178,62,0.32)" };
const GRAY = { bg: "rgba(255,255,255,0.05)", text: "#9AA39F", border: "rgba(255,255,255,0.12)" };
const BLUE = { bg: "rgba(96,165,250,0.12)", text: "#82B7F6", border: "rgba(96,165,250,0.32)" };
const RED = { bg: "rgba(224,90,74,0.12)", text: "#EC8B7F", border: "rgba(224,90,74,0.34)" };

export const STATUS_STYLES = {
  // Construction
  "Not Started": GRAY,
  "Upcoming": GRAY,
  "In Progress": AMBER,
  "Completed": TEAL,
  "Delayed": RED,
  "Current": AMBER,
  // Warranty
  "Active": TEAL,
  "Expiring Soon": AMBER,
  "Expired": GRAY,
  // Service request statuses
  "Submitted": BLUE,
  "Under Review": BLUE,
  "Additional Information Needed": AMBER,
  "Approved": TEAL,
  "Not Covered": RED,
  "Contractor Assigned": BLUE,
  "Scheduling": AMBER,
  "Scheduled": AMBER,
  "Work Completed": TEAL,
  "Homeowner Confirmation": AMBER,
  "Closed": GRAY,
  // Priority
  "Low": GRAY,
  "Normal": BLUE,
  "High": AMBER,
  "Urgent": RED,
};

export function StatusPill({ status, className = "" }) {
  const s = STATUS_STYLES[status] || GRAY;
  return (
    <span
      data-testid={`status-pill-${(status || "").toLowerCase().replace(/\s+/g, "-")}`}
      className={`inline-flex items-center gap-1.5 px-2.5 py-0.5 text-[10px] font-bold uppercase tracking-widest border rounded-sm whitespace-nowrap ${className}`}
      style={{ backgroundColor: s.bg, color: s.text, borderColor: s.border }}
    >
      {status}
    </span>
  );
}

export function warrantyState(expiration) {
  if (!expiration) return "Active";
  const today = new Date();
  const exp = new Date(expiration);
  const days = (exp - today) / 86400000;
  if (days < 0) return "Expired";
  if (days <= 90) return "Expiring Soon";
  return "Active";
}
